import React from 'react';
import styled from 'styled-components';

import type { MultiselectPickerItemComponentProps } from 'components/shared/forms/MultiselectPicker';
import type { ShowcaseProjectMediaItem } from 'data/v3/showcases';

const Image = styled.img`
  width: 100%;
  object-fit: cover;
  border-radius: var(--cc_size_border_radius_l);
  aspect-ratio: 1;
  background-color: var(--cc_color_background_3);
`;

type MediaItemProps =
  MultiselectPickerItemComponentProps<ShowcaseProjectMediaItem>;

export default function MediaItem(props: MediaItemProps) {
  return <Image src={props.item.thumbnailUrl} />;
}
